import { createContext, useContext } from 'react';

export interface SubmissionModalContext {
  cancel: () => void;
  submit: () => void;
}

export const SubmissionModalContext = createContext<SubmissionModalContext>(null!);

export const useSubmissionModalContext = () => useContext(SubmissionModalContext);
